<template>
	<r-pop-menu
		:class="{
			'datefield-picker-cell': theme === 'cell',
		}"
		:relative="popRelative"
		:relativeAlignmentContainer="0"
		:relativeAlignmentActivator="(theme === 'list' && dateName === 'startDate' ? -0.25 : 0)"
		:spaceBetweenActivatorAndContent="1"
		:popActivatorStyleOverride="{
			'width': (theme === 'cell' ? '100%' : ''),
			'height': (theme === 'cell' ? '100%' : ''),
		}"
	>
		<r-pop-list-item 
			v-if="theme === 'list'"
			slot="activator" 
			class="current-field-label list"
			:class="{
				warn: currentSelectedDateFieldGUID === null,
			}"
			:moreIcon="true"
		>
			<div
				class="field-label-selection"
			>
				<div class="icon-left">
					<r-standard-icon
						:icon="iconName"						
					></r-standard-icon>
				</div>
				<span class="label-text" v-if="currentSelectedDateFieldGUID">
					<template v-if="currentSelectedDateFieldGUID">
						Tasks {{ dateEdgeText }} on: 
						<universal-field-label-display
							:dataStore="sheetView.sheetViewGroup.dataStore"
							:fieldGUID="currentSelectedDateFieldGUID"
						></universal-field-label-display>
					</template>
					<template v-else>
						Tasks {{ dateEdgeText }} on: Date Field Missing
					</template>					
				</span>
				<span 
					v-else
					class="label-text"
				>
					Date Field Missing
				</span>
			</div>
		</r-pop-list-item>
		<div 
			v-else
			slot="activator" 
			class="current-field-label"
			:class="{
				warn: currentSelectedDateFieldGUID === null,
				header: theme === 'header',
				cell: theme === 'cell',
			}"
		>
			<span class="label-text" v-if="currentSelectedDateFieldLabel">
				<span v-if="theme === 'header' && dateName === 'startDate'">[</span>
				<span v-if="theme === 'header' && dateName === 'endDate'">to </span>
				<!-- <universal-field-label-display
					v-if="currentSelectedDateFieldGUID"
					:dataStore="sheetView.sheetViewGroup.dataStore"
					:fieldGUID="currentSelectedDateFieldGUID"
				></universal-field-label-display>
				<span
					v-else
				>
					Date Field Missing
				</span> -->
				{{currentSelectedDateFieldLabel}}
				<span v-if="theme === 'header' && dateName === 'endDate'">]</span>
			</span>
			<span 
				v-else
				class="label-text"
			>
				Date Field Missing
			</span>
			<r-standard-icon
				icon="smallArrowDown"
				class="label-arrow"
				:size="{
					height: 6,
					width: 9,
				}"
				:containerSize="30"
				hexColor="#C3C9D4"				
			></r-standard-icon>
		</div>
		<div slot="content" class="date-pop-content">
			<r-pop-list>
				<r-pop-list-item
					v-for="fieldStruct, fieldIndex in availableDateFields"
					:key="fieldStruct.fieldGUID"
					@pointerdown="fieldSelected(fieldStruct.fieldGUID)"
				>
					<div class="list-item">
						<div class="possible-checkmark">
							<r-standard-icon
								class="checkmark-icon"
								v-if="fieldStruct.fieldGUID === currentSelectedDateFieldGUID"
								icon="checkMark"
							></r-standard-icon>
						</div>
						<div 
							class="choice-label"
							:class="{
								'other-date': fieldStruct.fieldGUID === currentOtherSelectedDateFieldGUID,
							}"
						>
							<universal-field-label-display
								:dataStore="sheetView.sheetViewGroup.dataStore"
								:fieldGUID="fieldStruct.fieldGUID"
							></universal-field-label-display>
						</div>
					</div>
				</r-pop-list-item>
				<r-pop-list-item
					@pointerdown="addNewDateField"
				>
					<div class="list-item">
						<div class="possible-checkmark">
							<r-standard-icon
								class="plus-icon"
								icon="dropdownPlus"
								:color="'grey-400'"								
							></r-standard-icon>
						</div>
						<div class="add-new-label">
							New date field
						</div>
					</div>
				</r-pop-list-item>
			</r-pop-list>
		</div>
	</r-pop-menu>
</template>

<script type="text/javascript">

	import UniversalFieldLabelDisplay from 'vue/sheet-views/common/fields/universal-field-label-display.vue';
	import TimelineDateExample from 'vue/sheet-views/common/fields/svg-examples/timeline-date-example';

	export default{
		inject:['sheetGlobalState'],
		props:{
			sheetView:{
				required: true,
				type: Object,
			},
			dateName:{ //startDate or endDate
				required: true,
				type: String,
			},
			theme:{
				required: false,
				type: String,
				default: "header",
			},
		},
		$pubsub:{
			newColumnModal:{},
		},
		components:{
			UniversalFieldLabelDisplay,
		},
		computed:{
			schema(){
				return this.sheetGlobalState.dataStore.meta.schema;
			},
			currentSelectedDateFieldGUID(){
				if(!!this.schema.fields[this.sheetView.properties.fields[this.dateName]]){
					return this.sheetView.properties.fields[this.dateName];
				}
				return null;
			},
			currentSelectedDateField(){
				if(this.currentSelectedDateFieldGUID){
					return this.schema.fields[this.currentSelectedDateFieldGUID];
				}				
			},
			currentSelectedDateFieldLabel(){
				if(this.currentSelectedDateFieldGUID){
					return this.currentSelectedDateField.display.label;
				}
				else{
					return "Date Field Missing";
				}
			},
			otherDateName(){
				if(this.dateName === "startDate"){
					return "endDate";
				}
				else{
					return "startDate";
				}
			},
			dateEdgeText(){
				if(this.dateName === "startDate"){
					return "start";
				}
				else{
					return "end";
				}
			},
			popRelative(){
				if(this.theme === "list"){
					return "right";
				}
				else{
					return "bottom";
				}
			},
			iconName(){
				if(this.dateName === "startDate"){
					return "leftEdge"
				}
				else{
					return "rightEdge";
				}
			},
			currentOtherSelectedDateFieldGUID(){
				if(!!this.schema.fields[this.sheetView.properties.fields[this.otherDateName]]){
					return this.sheetView.properties.fields[this.otherDateName];
				}
				return null;
			},
			availableNativeDateFields(){
				const vcSelf = this;
				return Object.keys(vcSelf.schema.fields).filter(function includeDateFields(fieldGUID){
					return vcSelf.schema.fields[fieldGUID].field.fieldType === 'date';
				}).map(function generateFieldStruct(fieldGUID){
					return {
						fieldGUID,
						field: vcSelf.schema.fields[fieldGUID],
						source: 'native',
					}
				});
			},
			availableExternalEntityFieldDateFields(){
				const vcSelf = this;
				return Object.keys(vcSelf.schema.fields).filter(function includeDateFields(fieldGUID){
					if(vcSelf.schema.fields[fieldGUID].field.fieldType === 'externalEntityField'){
						let linkedFieldKey = vcSelf.schema.fields[fieldGUID].field.attributes.externalField;
						let linkedFieldEELGUID = vcSelf.schema.fields[fieldGUID].field.attributes.externalEntityLinkField;
						let eel = vcSelf.schema.fields[linkedFieldEELGUID];
						if(eel){
							let connectedAppName = eel.field.attributes.connectedAppName;

							if(vcSelf.$root.systemState.auth.organization){
								if(vcSelf.$root.systemState.auth.organization.connectionsManifestObject){
									const cmo = vcSelf.$root.systemState.auth.organization.connectionsManifestObject;
									if(cmo.connectedApps[connectedAppName]){
										const caic = cmo.connectedApps[connectedAppName].connectedAppIntegrationConfiguration;

										if(caic){
											let externalEntityType;
											//Split logic based on app
											if(connectedAppName === 'jira'){
												externalEntityType = 'Issue';
											}
											else{
												//Non special app, use default
											}

											if(caic.configuration.entities[externalEntityType]){
												if(caic.configuration.entities[externalEntityType].fields[linkedFieldKey]){
													const linkedFieldDetails = caic.configuration.entities[externalEntityType].fields[linkedFieldKey];
													if(linkedFieldDetails.field){
														let fieldType = linkedFieldDetails.field.fieldType;

														if(fieldType === 'date'){
															return true;
														}
													}													
												}
												else{
													//Field not found for entity
												}
											}
											else{
												//Entity type not in caic
											}
										}
									}
									else{
										//App not in CMO
									}
								}
								else{
									//No CMO loaded
								}
							}
							else{
								//No ORG loaded
							}
						}
					}
				}).map(function generateFieldStruct(fieldGUID){
					return {
						fieldGUID,
						field: vcSelf.schema.fields[fieldGUID],
						source: 'connectedApp',
					}
				});
			},
			availableDateFields(){
				return this.availableNativeDateFields.concat(this.availableExternalEntityFieldDateFields).sort(function sortByName(fieldStructA, fieldStructB){
					return fieldStructA.field.display.label.localeCompare(fieldStructB.field.display.label);					
				})
			}
		},
		methods:{
			fieldSelected(fieldGUID){
				this.sheetView.timelineDateFieldChanged(this.dateName, fieldGUID);	

				this.$pubsub.modules.UI.pub('actionTaken', {
					actionClass: 'dataStoreTimelineUI',
					action: 'changeDateField',
					details: {										
						dateName: this.dateName,
						fieldGUID,								
					},
				});
			},
			addNewDateField(){
				const vcSelf = this;
				vcSelf.$pubsub.modules.newColumnModal.pub('openModal', {
					sheetView: vcSelf.sheetView,
					overrideObject:{
						title: 'Add New Date Field to Plot',
						subtitle: 'Add a new date field to each project that you can plot on the timeline.',
						fieldType: 'date',
						fieldTerminology: true,
						showFeatures: false,
						example: TimelineDateExample,
						onCompletedCallback(editedSheetView, addedFieldGUID){
							vcSelf.fieldSelected(addedFieldGUID);
						},
					}
				});
			},
		}
	};
</script>


<style lang="scss" scoped>

	.datefield-picker-cell{
		width: 100%;
		height: 100%;
	}

	.date-pop-content{
		width: 200px;

		.list-item{
			display: grid;
			grid-template-columns: 39px 1fr;

			.possible-checkmark{

				.checkmark-icon{

				}

				.plus-icon{

				}
			}

			.choice-label{
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 26px;

				&.other-date{
					color: $p-color-grey-400;
				}
			}
			.add-new-label{
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 26px;
				color: $p-color-grey-400;
			}
		}
	}		

	
	.current-field-label{
		font-size: 14px;
		line-height: 100%;
		cursor: pointer;
		color: $p-color-grey-600;
		padding: 6px 0px;

		&.warn{
			color: $p-color-orange-300;
			background-color: #FFF3EC;
		}

		&.header{
			color: $p-color-grey-500;
		}

		&.cell{
			padding: 0 0 0 12px;			
			height: 100%;
			width: 100%;
			display: flex;
			align-items: center;

			.label-text{
				flex-grow: 1;
			}		

			&.warn{
				color: $p-color-grey-400;
				background-color: initial;
			}
		}

		&.list{
			width: 100%;
			padding: 0 9px;
		}

		.field-label-selection{
			@include flex(row);

			.icon-left{
				height: 24px;
				width: 24px;
				margin-right: 9px;
			}
		}

		.label-arrow{
			width: 30px;
			height: 30px;
			cursor: pointer;		
			display: flex;
			align-items: center;
			justify-content: center;
			align-content: center;
			justify-items: center;
		}
	}

</style>